import type { DashboardTab } from "./dashboardUtils";

export type { DashboardTab };

const TAB_LABELS: Record<DashboardTab, string> = {
  cashflow: "Cashflow",
  receivables: "Receivables",
};

type Props = {
  tabs: DashboardTab[];
  active: DashboardTab;
  onChange: (tab: DashboardTab) => void;
};

export function DashboardTabs({ tabs, active, onChange }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Dashboard sections"
      className="inline-flex rounded-lg border border-slate-200 bg-slate-100 p-1"
    >
      {tabs.map((tab) => (
        <button
          key={tab}
          type="button"
          role="tab"
          aria-selected={active === tab}
          onClick={() => onChange(tab)}
          className={`rounded-md px-4 py-1.5 text-sm font-medium transition-colors ${
            active === tab
              ? "bg-white text-slate-900 shadow-sm"
              : "text-slate-500 hover:text-slate-700"
          }`}
        >
          {TAB_LABELS[tab]}
        </button>
      ))}
    </div>
  );
}
